<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Próximas viagens programadas</div>
            </div>
            <div class="card-body">
              <div class="row mb-5 mt-3 justify-content-center">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="chartSpot">Cidade de Destino</label>
                    <v-select
                      :options="cityDestinations"
                      label="description"
                      :clearable="false"
                      :reduce="(cityDestinations) => cityDestinations.id"
                      class="style-chooser"
                      placeholder="Selecione a cidade que você pretende visitar"
                      v-model="filter.city_destination"
                    >
                      <div slot="no-options">Carregando...</div>
                    </v-select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="chartDateStart">Data de Saída</label>
                    <CtkDateTimePicker
                      v-model="filter.retreat_date"
                      :color="$store.state.date_picker_color"
                      locale="pt-br"
                      no-label
                      only-date
                      :auto-close="true"
                      formatted="ll"
                      button-now-translation="Hoje"
                      class="datetimepicker"
                      label="Selecione a data que você pretende viajar"
                      format="YYYY-MM-DD"
                      id="retreat_date"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="chartDateStart">Data de Retorno</label>
                    <CtkDateTimePicker
                      v-model="filter.devolution_date"
                      :color="$store.state.date_picker_color"
                      locale="pt-br"
                      no-label
                      :auto-close="true"
                      only-date
                      formatted="ll"
                      button-now-translation="Hoje"
                      class="datetimepicker"
                      label="Selecione a data que você pretende retornar"
                      format="YYYY-MM-DD"
                      id="retreat_date"
                    />
                  </div>
                </div>
                <div class="col-md-12" align="center">
                  <button class="btn btn-default" @click="getNextTrips">
                    Buscar Viagens
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12" v-for="trip in trips" :key="trip.id">
                  <div class="card">
                    <div class="card-body">
                      <label style="font-size: 12px">Destino</label>
                      <h6 class="card-subtitle mb-2 text-muted">
                        <i class="fas fa-map-marker-alt"></i>
                        {{ trip.city_destination.description }}
                      </h6>
                      <p class="card-text">
                        <i class="fa fa-building" aria-hidden="true"></i>

                        <strong>Filial de Saída:</strong>
                        {{ trip.reserve.branch.description }}
                      </p>
                      <p class="card-text">
                        <i class="fas fa-user"></i> <strong>Usuário:</strong>
                        {{ trip.reserve.user.name }}
                      </p>
                      <p class="card-text">
                        <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        <strong>Data de Saída:</strong>
                        {{ trip.reserve.retreat_date }}
                      </p>
                      <p class="card-text">
                        <i class="fa fa-arrow-left mr-2" aria-hidden="true"></i>
                        <strong>Data de Retorno:</strong>
                        {{ trip.reserve.devolution_date }}
                      </p>
                      <p class="card-text">
                        <i class="fa fa-car" aria-hidden="true"></i>
                        <strong>Veículo:</strong>
                        {{ getVehicleDescription(trip.reserve) }}
                      </p>
                      <p class="card-text mb-3">
                        <i class="fa fa-id-card" aria-hidden="true"></i>
                        <strong>Placa Veículo:</strong>
                        {{ getVehicleBoard(trip.reserve) }}
                      </p>
                      <div align="center">
                        <button
                          class="btn btn-default centered"
                          data-tooltip="tooltip"
                          title="Dados do Usuário"
                          data-dismiss="modal"
                          data-toggle="modal"
                          @click="openModalUser(trip.reserve.user)"
                        >
                          <i class="fas fa-user"></i> Visualizar Dados do
                          Usuário
                        </button>
                        <button
                          class="btn btn-default centered mt-3"
                          data-tooltip="tooltip"
                          title="Dados do Usuário"
                          data-dismiss="modal"
                          data-toggle="modal"
                          @click="openModalCarona(trip)"
                        >
                          <i class="fas fa-users"></i> Pedir Carona
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-12 text-center mb-5"
                  v-if="trips.length == 0"
                >
                  <strong
                    >Nenhuma viagem programada para a rota e/ou período
                    informado.</strong
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="receiveds.length > 0">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Pedidos de carona recebidos</div>
            </div>
            <div class="card-body">
              <div class="row">
                <div
                  class="col-md-12"
                  v-for="received in receiveds"
                  :key="received.id"
                >
                  <div class="card">
                    <div class="card-body">
                      <label style="font-size: 12px">Destino</label>
                      <h6 class="card-subtitle mb-2 text-muted">
                        <i class="fas fa-map-marker-alt"></i>
                        {{ received.city_destination.description }}
                      </h6>

                      <p class="card-text">
                        <i class="fas fa-user"></i> <strong>Usuário:</strong>
                        {{ received.requester.name }}
                      </p>
                      <p class="card-text">
                        <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        <strong>Data de Saída:</strong>
                        {{ received.reserve.retreat_date }}
                      </p>
                      <p class="card-text">
                        <i class="fa fa-arrow-left mr-2" aria-hidden="true"></i>
                        <strong>Data de Retorno:</strong>
                        {{ received.reserve.devolution_date }}
                      </p>
                      <p class="card-text">
                        <i class="fa fa-align-justify" aria-hidden="true"></i>
                        <strong>Observação do Requisitante:</strong>
                        {{ received.requester_observation }}
                      </p>

                      <div v-if="received.status == 1">
                        <p class="card-text mt-3 centered">
                          <button
                            class="btn btn-default"
                            @click="openModalApprove(received)"
                          >
                            Aprovar
                          </button>
                          <button
                            class="btn btn-cancel"
                            @click="changeStatus(received, 3)"
                          >
                            Rejeitar
                          </button>
                        </p>
                      </div>
                      <div v-else>
                        <p class="card-text mt-2 centered">
                          <span
                            style="font-size: 14px"
                            :class="
                              'badge badge-' +
                              (received.status == 1
                                ? 'warning'
                                : received.status == 2
                                ? 'success'
                                : 'danger')
                            "
                            >{{
                              received.status == 1
                                ? "Aguardando"
                                : received.status == 2
                                ? "Aprovada"
                                : "Rejeitada"
                            }}</span
                          >
                        </p>
                      </div>
                      <div class="centered">
                        <button
                          class="btn btn-default centered mt-3"
                          data-tooltip="tooltip"
                          title="Dados do Usuário"
                          data-dismiss="modal"
                          data-toggle="modal"
                          @click="openModalUser(received.requester)"
                        >
                          <i class="fas fa-user"></i> Visualizar Dados do
                          Usuário
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-12 text-center mb-5"
                  v-if="trips.length == 0"
                >
                  <strong
                    >Nenhuma viagem programada para a rota e/ou período
                    informado.</strong
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="requesteds.length > 0">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Pedidos de carona solicitados</div>
            </div>
            <div class="card-body">
              <div class="row">
                <div
                  class="col-md-12"
                  v-for="requested in requesteds"
                  :key="requested.id"
                >
                  <div class="card" v-if="requested.requested && requested.city_destination && requested.reserve ">
                    <div class="card-body">
                      <label style="font-size: 12px">Destino</label>
                      <h6 class="card-subtitle mb-2 text-muted">
                        <i class="fas fa-map-marker-alt"></i>
                        {{ requested.city_destination.description }}
                      </h6>

                      <p class="card-text">
                        <i class="fas fa-user"></i> <strong>Usuário:</strong>
                        {{ requested.requested.name }}
                      </p>
                      <p class="card-text">
                        <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        <strong>Data de Saída:</strong>
                        {{ requested.reserve.retreat_date }}
                      </p>
                      <p class="card-text">
                        <i class="fa fa-arrow-left mr-2" aria-hidden="true"></i>
                        <strong>Data de Retorno:</strong>
                        {{ requested.reserve.devolution_date }}
                      </p>
                      <p class="card-text">
                        <i class="fa fa-align-justify" aria-hidden="true"></i>
                        <strong>Observação do Requisitante:</strong>
                        {{ requested.requested_observation }}
                      </p>

                      <p class="card-text mt-2 centered">
                        <span
                          style="font-size: 14px"
                          :class="
                            'mt-2 badge badge-' +
                            (requested.status == 1
                              ? 'warning'
                              : requested.status == 2
                              ? 'success'
                              : 'danger')
                          "
                          >{{
                            requested.status == 1
                              ? "Aguardando"
                              : requested.status == 2
                              ? "Aprovada"
                              : "Rejeitada"
                          }}</span
                        >
                      </p>

                      <div class="centered">
                        <button
                          class="btn btn-default mt-3"
                          data-tooltip="tooltip"
                          title="Dados do Usuário"
                          data-dismiss="modal"
                          data-toggle="modal"
                          @click="openModalUser(requested.requested)"
                        >
                          <i class="fas fa-user"></i> Visualizar Dados do
                          Usuário
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-12 text-center mb-5"
                  v-if="trips.length == 0"
                >
                  <strong
                    >Nenhuma viagem programada para a rota e/ou período
                    informado.</strong
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>

    <user-modal
      :modalStatus="modalUserStatus"
      :dataModal="dataModalUser"
      @changeModal="changeUserModal"
      v-if="loadModalUser"
    ></user-modal>

    <div
      id="modalCarona"
      v-if="dataModalCarona"
      class="modal"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Pedir carona</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                Você está solicitando uma carona para:
                <strong>{{
                  dataModalCarona.city_destination.description
                }}</strong>
                no dia
                <strong>{{ dataModalCarona.reserve.retreat_date }}</strong>
              </div>
              <div class="col-md-12 mt-3">
                <label for="requester_observation"
                  >Deseja enviar alguma observação ao
                  {{ dataModalCarona.reserve.user.name }}?</label
                >
                <textarea
                  name="requester_observation"
                  class="form-control"
                  id="requester_observation"
                  cols="30"
                  rows="10"
                  v-model="dataModalCarona.requester_observation"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="getRide">
              Pedir Carona
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="modalApprove"
      v-if="dataModalApprove"
      class="modal"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Aprovar pedido de carona</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                Você está aprovando uma carona para:
                <strong>{{
                  dataModalApprove.city_destination.description
                }}</strong>
                no dia
                <strong>{{ dataModalApprove.reserve.retreat_date }}</strong
                >, para o usuário
                <strong>{{ dataModalApprove.requester.name }}</strong
                >.
              </div>
              <div class="col-md-12">
                <label for="requester_observation"
                  >Em que dia e horário vocês devem se encontrar?</label
                >
                <CtkDateTimePicker
                  v-model="dataModalApprove.departure_date"
                  :color="$store.state.date_picker_color"
                  locale="pt-br"
                  no-label
                  button-now-translation="Hoje"
                  class="datetimepicker"
                  label="Selecione a data que você pretende viajar"
                  format="YYYY-MM-DD HH:mm:ss"
                  id="retreat_date"
                />
              </div>
              <div class="col-md-12 mt-3">
                <label for="requester_observation"
                  >Deseja enviar alguma observação ao
                  {{ dataModalApprove.requester.name }}?</label
                >
                <textarea
                  name="requester_observation"
                  class="form-control"
                  id="requester_observation"
                  cols="30"
                  rows="10"
                  v-model="dataModalApprove.requested_observation"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click="changeStatus(dataModalApprove, 2)"
            >
              Aprovar Carona
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Pagination } from "vue-pagination-2";
import UserModal from "../Modals/UserModal";
import CtkDateTimePicker from "vue-ctk-date-time-picker";
import {getMessage} from "../../composables/message";
import {shouldHideVehicleData} from "../../composables/useVehicleVisibility";
export default {
  data() {
    return {
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      isLoading: true,
      fullPage: true,
      trips: [],
      receiveds: [],
      requesteds: [],
      cityDestinations: [],
      modalUserStatus: false,
      loadModalUser: false,
      dataModalUser: {},
      dataModalCarona: "",
      dataModalApprove: "",
      filter: {},
    };
  },

  computed: {},
  methods: {
    getVehicleDescription(reserve) {
      const user = this.$store.state.user;
      if (!reserve || !reserve.vehicles) return 'N/A';
      if (shouldHideVehicleData(user, reserve)) {
        return 'Veículo Oculto';
      }
      return reserve.vehicles.description;
    },
    getVehicleBoard(reserve) {
      const user = this.$store.state.user;
      if (!reserve || !reserve.vehicles) return 'N/A';
      if (shouldHideVehicleData(user, reserve)) {
        return '***-***';
      }
      return reserve.vehicles.board;
    },
    openModalCarona(object) {
      this.dataModalCarona = object;
      $("#modalCarona").modal("toggle");
    },
    changeUserModal(status) {
      this.modalUserStatus = status;
    },
    openModalApprove(data) {
      this.dataModalApprove = data;
      $("#modalApprove").modal("toggle");
    },
    getRide: function () {
      const self = this;
      const api = self.$store.state.api + "rides/request";

      self.$http
        .post(api, self.dataModalCarona)
        .then((response) => {
          $("#modalCarona").modal("toggle");

          self.getNextTrips();
          swal(
            "Sucesso",
            "Enviamos seu pedido de carona, fique atento ao seu e-mail, em breve você receberá um retorno!",
            "success"
          );
        })
        .catch((error) => {
          const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
        });
    },
    changeStatus: function (data, status) {
      const self = this;
      const api = self.$store.state.api + "rides/change-status";

      var dateDpt;
      if (this.dataModalApprove.departure_date != undefined) {
        dateDpt = this.dataModalApprove.departure_date;
      } else {
        dateDpt = null;
      }

      self.$http
        .post(api, { data: data, status: status, departure_date: dateDpt })
        .then((response) => {
          if (status == 2) {
            $("#modalApprove").modal("toggle");
          }
          self.getNextTrips();
          swal(
            "Sucesso",
            "Atualizamos a solicitação, avisaremos ao solicitante sobre sua decisão!",
            "success"
          );
        })
        .catch((error) => {
          const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
        });
    },
    getNextTrips: function () {
      const self = this;
      const api = self.$store.state.api + "next-trips-open/1";

      self.isLoading = true;

      self.$http
        .post(api, { filters: self.filter })
        .then((response) => {
          self.trips = response.data.reserves;
          self.receiveds = response.data.receiveds;
          self.requesteds = response.data.requesteds;

          self.isLoading = false;
        })
        .catch((error) => {
          const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
        });
    },
    getCityDestinations: function () {
      const self = this;
      const api =
        self.$store.state.api + "cityDestinations_open/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.cityDestinations = response.data.data;
        })
        .catch((error) => {
          const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
        });
    },
    openModalUser(object) {
      var obj = {};
      obj.user = object;
      this.modalUserStatus = true;
      this.dataModalUser = obj;
      this.loadModalUser = true;
    },
    changeUserModal(status) {
      this.modalUserStatus = status;
    },
  },
  mounted: function () {
    const self = this;

    self.getNextTrips();
    self.getCityDestinations();
  },
  components: { Loading, Pagination, UserModal, CtkDateTimePicker },
};
</script>
<style scoped>
.card-text {
  margin-bottom: -5px;
}
i {
  font-size: 12px;
  margin-right: 2px;
}
.card-subtitle {
  font-weight: 700;
  border-top: 0px solid #3fa110;
  border-bottom: 1px solid #3fa110;
  padding: 0.3rem;
}
</style>

<style>
.uploading-image {
  display: flex;
}

.max {
  width: 60%;
}

.comment {
  margin-top: 15px;
  background-color: #efefef;
  padding: 15px;
}
.h-10 {
  height: 20px;
}
.centered {
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/NextTrips/IndexWebview.vue